<template>
    <div class="d-flex flex-column bg-white">
        <HeaderBar/>
        <div class="reportTitle mt-5 ml-1">Estado Reproductivo</div>
        <b-card header-border-variant="Primary" class="shadow  px-0" no-body>
            <b-row no-gutters>

                <b-card-body>
                    <span style="font-weight: 600;font-size: 18px;">
                        
                        <div class="d-flex justify-content-between">
                            <b-form-datepicker id="fecha_ini" name="fecha_ini" v-model="init_date" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            :min="minCfgDate" :max="maxCfgDate"
                            locale="es-ES"/>

                            <b-form-datepicker id="fecha_fin" name="fecha_fin" v-model="end_date" 
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                            :min="minCfgDate" :max="maxCfgDate"
                            locale="es-ES"/>
                           
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>Indicador Reproductivo</div>
                            <div>Resultado</div>
                        </div>
                    </span>

                    <blockquote class="blockquote mb-0"></blockquote>

                    <b-card-text class="mt-3 mb-3">
                        <div class="d-flex justify-content-between">
                            <div> Vacas Preñadas:</div>
                            <div> {{pregNumbers}}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Hembras Nacidas:</div>
                            <div> {{femalePercentage}} %</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Machos Nacidos:</div>
                            <div> {{malesPercentage}} %</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Mortalidad Total:</div>
                            <div>{{deathPercentage}} % </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Mortalidad Nacimientos:</div>
                            <div>{{deadparts}} % </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Promedio de Intervalo entre partos:</div>
                            <div>{{intervalAvg}} </div>
                        </div><div class="d-flex justify-content-between">
                            <div> Vacas Abiertas:</div>
                            <div>{{opens}} </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div> Tasa de Parición:</div>
                            <div>{{pregnant_percent}} %</div>
                        </div>
                        <!--<div class="d-flex justify-content-between">
                            <div> Partos:</div>
                            <div> {{parts}}</div>
                        </div>
                         <div class="d-flex justify-content-between">
                            <div> Intervalo de partos:</div>
                            <div> {{animal_charge}}</div>
                        </div> 
                        <div class="d-flex justify-content-between">
                            <div> Abortos:</div>
                            <div> {{abortions}}</div>
                        </div>
                        

                        <div class="d-flex justify-content-between">
                            <div>Andrología:</div>
                            <div> {{andrology}}</div>
                        </div>-->

                    <!-- <div class="d-flex justify-content-between mt-2 px-1">
                        <b-button class="bg-primary w-100 mr-1">Resumen General</b-button>
                    </div> -->
                    </b-card-text>
                </b-card-body>

            </b-row>
        </b-card>
        <div class="d-flex justify-content-between mt-2 px-1">
            <b-button class="bg-primary w-100 mr-1" @click="modalShow=true">Vacas preñadas</b-button>
        </div>
        <div class="d-flex justify-content-between mt-2 px-1">
            <b-button class="bg-primary w-100 mr-1" @click="modalShow2=true">Vacas secas</b-button>
        </div>
        <b-modal size="sm" centered v-model="modalShow" hide-footer hide-header>
            <vue-good-table :columns="columns2" :rows="pregnants" styleClass="vgt-table bordered"
             :search-options="{
                 enabled: false,
             }" 
             
             :pagination-options="{
                 enabled: true,
                 perPage: pageLength
             }"
             
             :sort-options="{
                 enabled: true,
             }"

             >
             <template slot="table-row" slot-scope="props">

 

                 <!-- Column: Common -->
                 <span>
                 {{ props.formattedRow[props.column.field] }}
                 </span>
             </template>

             <!-- pagination -->
             <template slot="pagination-bottom" slot-scope="props">
                 <div class="d-flex justify-content-between flex-wrap">
                 <div class="d-flex align-items-center mb-0 mt-1">
                     <span class="text-nowrap ">
                     Mostrando 1 de
                     </span>
                     <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                     @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                     <span class="text-nowrap"> of {{ props.total }} registros </span>
                 </div>
                 </div>
             </template>
             </vue-good-table> 
         </b-modal>
         <b-modal size="sm" centered v-model="modalShow2" hide-footer hide-header>
            <vue-good-table :columns="columns" :rows="dryed" styleClass="vgt-table bordered"
             :search-options="{
                 enabled: false,
             }" 
             
             :pagination-options="{
                 enabled: true,
                 perPage: pageLength
             }"
             
             :sort-options="{
                 enabled: true,
             }"

             >
             <template slot="table-row" slot-scope="props">

 

                 <!-- Column: Common -->
                 <span>
                 {{ props.formattedRow[props.column.field] }}
                 </span>
    
                 <span v-if="props.column.field === 'id'" class="text-center">
                    <b-button class="delete-button" variant="warning" @click="outDryedCow(props.row.id)">x</b-button>
                 </span>
             </template>

             <!-- pagination -->
             <template slot="pagination-bottom" slot-scope="props">
                 <div class="d-flex justify-content-between flex-wrap">
                 <div class="d-flex align-items-center mb-0 mt-1">
                     <span class="text-nowrap ">
                     Mostrando 1 de
                     </span>
                     <b-form-select v-model="pageLength" :options="['25', '50', '100']" class="mx-1"
                     @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                     <span class="text-nowrap"> of {{ props.total }} registros </span>
                 </div>
                 </div>
             </template>
             </vue-good-table> 
         </b-modal>
        <ControlMenu />
    </div>
</template>


<script>
import { BCard, BRow, BCardBody, BCardText, BButton, BFormSelect, BFormDatepicker, BFormRadio} from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue';
import HeaderBar from '@/components/HeaderBar.vue';
import Ripple from 'vue-ripple-directive'
import { VueGoodTable } from 'vue-good-table'
import animal from '@/store/animal';
export default {
    components: {
        BCard,
        BButton,
        BCardBody,
        BCardText,
        BRow,
        ControlMenu,
        HeaderBar,
        VueGoodTable,
        BFormSelect,
        BFormRadio,
        BFormDatepicker
    },
    directives: {
    Ripple,
  },
  data(){
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 500)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return{
        dateFormat:'%n/%Y',
        maxCfgDate:maxDate,
        minCfgDate:minDate,
        setLang:'es',
        init_date:now,
        end_date:now,
        modalShow:false,
        modalShow2:false,
        animals:0,
        report:"Mes",
        pregnant_percent:0,
        pregnants:null,
        pregNumbers:0,
        dryed:null,
        pageLength: 25,
        animal_charge:0,
        dest_weight:0,
        incomes:0,
        avg_weight:0,
        expenses:0,
        milk:0,
        dayli:0,
        reproductive:0,
        parts:0,
        deadparts:0,
        opens:0,
        intervalAvg:0,
        deathPercentage:0,
        abortions:0,
        palpations:0,
        andrology:0,
        malesPercentage:0,
        femalesPercentage:0,
        columns: [
        
        {
          label:  'CODIGO',
          field:  'number',
          type:   'string'
        },  
        {
          label:  'ANIMAL',
          field:  'name',
          type:   'string'
        },
        {
          label:  'PESO',
          field:  'weight',
          type:   'number'
        },
        {
          label:  'EDAD',
          field:  'age',
          type:   'number'
        },
        {
          label:  'SACAR',
          field:  'id',
          type:   'number'
        }
      ],
      columns2: [
        
        {
          label:  'CODIGO',
          field:  'number',
          type:   'string'
        },  
        {
          label:  'ANIMAL',
          field:  'name',
          type:   'string'
        },
        {
          label:  'PESO',
          field:  'weight',
          type:   'number'
        },
        {
          label:  'EDAD',
          field:  'age',
          type:   'number'
        }
      ],
    }
  },
  methods:{
    async fetchAnimals(config){
      let farmId= localStorage.getItem('currentFarm');
      fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log('Animals');
            console.log(result.animals);
            this.animals = result.animals.length;
            let animals= result.animals;
            console.log(this.animals);
            this.calculateGenderPercentage(result.animals, this.init_date, this.end_date);
            this.fetchAnimalsPregnant(config);
            fetch(this.$apiUrl+"list/animal_exits?farm_id="+farmId+"&recperpage=all", config)
            .then(response => response.json())
            .then(result => {
                console.log('Animals');
                console.log(result);
                //this.animals = result.animal_exits.length;
            // console.log(this.animals);
                //this.calculateGenderPercentage(result.animals, this.init_date, this.end_date);
                this.calculateDeathsPercentage( animals,result.animal_exits, this.init_date, this.end_date);
            }) 
        })
    },
    calculateDeathsPercentage(animals, animalExits, initDate, endDate){
        let initDateObj = new Date(initDate);
        let endDateObj = new Date(endDate);
        let totalAnimals= animals.length;
        console.log('Total Animals: ' + totalAnimals);
        console.table(animalExits);
        let deadPeriods = animalExits.filter(item => {
            let deathDate = new Date(item.date);
            return deathDate >= initDateObj && deathDate <= endDateObj;
        });
        console.table(deadPeriods);
        this.deathPercentage = totalAnimals > 0 ? ((deadPeriods.length / totalAnimals) * 100).toFixed(2) : 0;
        console.log('deathPercentage')
        console.log(this.deathPercentage);
    },

    calculateGenderPercentage(animals, initDate, endDate) {
        console.log('calculate')
        console.table(animals)
        // Convertir las fechas a objetos Date
        let initDateObj = new Date(initDate);
        let endDateObj = new Date(endDate);

        // Filtrar los animales nacidos en el rango de fechas
        let bornInPeriod = animals.filter(item => {
            let birthDate = new Date(item.birthdate);
            return birthDate >= initDateObj && birthDate <= endDateObj;
        });
        console.log('born in period');
        console.table(bornInPeriod);

        // Contar machos y hembras
        const totalBorn = bornInPeriod.length;
        const malesCount = bornInPeriod.filter(animal => animal.sex === false).length; // Machos
        const femalesCount = bornInPeriod.filter(animal => animal.sex === true).length; // Hembras

        // Calcular porcentajes
        const malePercentage = totalBorn > 0 ? (malesCount / totalBorn) * 100 : 0;
        const femalePercentage = totalBorn > 0 ? (femalesCount / totalBorn) * 100 : 0;
        this.malesPercentage= malePercentage.toFixed(2);
        this.femalePercentage= femalePercentage.toFixed(2);
        // Mostrar resultados
        console.log(`Total born: ${totalBorn}`);
        console.log(`Males: ${malesCount} (${malePercentage.toFixed(2)}%)`);
        console.log(`Females: ${femalesCount} (${femalePercentage.toFixed(2)}%)`);
    },

    async fetchAnimalsPregnant(config){
      let farmId= localStorage.getItem('currentFarm');
      fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1&pregnant=1&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log('preñadas')
            console.log(result.animals);
            this.pregnants=result.animals;
            this.pregNumbers= result.animals.length;
            console.log(this.animals);
        })
    },
    async fetchAnimalsDryed(config){
      let farmId= localStorage.getItem('currentFarm');
      fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1&dryed=1&recperpage=all", config)
        .then(response => response.json())
        .then(result => {
            console.log(result.animals);
            this.dryed=result.animals;
            //this.pregnant_percent = parseFloat(result.animals.length/this.animals);
            console.log(this.animals);
        })
    },

    outDryedCow(iD){
        let self=this;
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        self.$http.post("edit/animals/"+iD,{
            dryed:false
        },config);
        self.modalShow2=false;
        self.fetchAnimalsDryed(config);
    },

    async fetchReproductive(config){
        let initDate = this.init_date;
        let endDate= this.end_date;
        let initDateObj = new Date(initDate);
        let endDateObj = new Date(endDate);
        let farmId= localStorage.getItem('currentFarm');
        let self=this;
        this.reproductive=0;
        this.parts=0;
        this.deadparts=0;
        this.abortions=0;
        this.palpations=0;
        this.andrology=0;
        let arrparts=[];
        let arrdeadparts=[];
        let arrabortions=[];
        let arrpalpations=[];
        let arrreproductive=[];
        fetch(this.$apiUrl+"list/reproductive_records?farm_id="+farmId+"&recperpage=all&order=date&ordertype=ASC", config)
        .then(response => response.json())
        .then(result => {
            console.log(result);
            result.reproductive_records.filter(function(item){
                let itemRegDate= new Date(item.date);
                return itemRegDate>= initDateObj && itemRegDate<=endDateObj;
            }).map(item => {
                //Delivery
                if(item.type==4){
                    arrparts.push(item)
                    console.log(arrparts)
                    this.parts=(parseInt(arrparts.length))
                    if(item.dead==true){
                        arrdeadparts.push(item);
                        this.deadparts=(parseFloat(arrdeadparts.length)/parseFloat(arrparts.length)).toFixed(2)
                    }
                    console.log(this.parts)
                    const groupedByAnimalId = arrparts.reduce((acc, record) => {
                        if (!acc[record.animal_id]) {
                            acc[record.animal_id] = [];
                        }
                        acc[record.animal_id].push(new Date(record.date));
                        return acc;
                    }, {});
                    let totalInterval = 0;
                    let count = 0;console.log('intervalo');
                    for (const animalId in groupedByAnimalId) {
                    const dates = groupedByAnimalId[animalId];
                        if (dates.length > 1) {
                            // Ordenar las fechas
                            dates.sort((a, b) => a - b);
                            const firstDate = dates[0];
                            const lastDate = dates[dates.length - 1];
                            
                            // Calcular el intervalo en días
                            const interval = Math.floor((lastDate - firstDate) / (1000 * 60 * 60 * 24));
                            totalInterval += interval;
                            count++;
                        }
                    }

                    // Calcular el promedio
                    this.intervalAvg = count > 0 ? totalInterval / count : 0;
                }else if(item.type==5){
                    arrabortions.push(item)
                    console.log(arrabortions)
                    this.abortions=(parseInt(arrabortions.length))
                    console.log(this.abortions)
                }else if(item.type==6){
                    arrpalpations.push(item)
                    console.log(arrpalpations)
                    this.palpations=(parseInt(arrpalpations.length))
                    console.log(this.palpations)
                }else if(item.type==7){
                    arrreproductive.push(item)
                    console.log(arrreproductive)
                    this.reproductive=(parseInt(arrreproductive.length))
                    this.andrology=(parseInt(arrreproductive.length))
                    console.log(this.reproductive)
                }
                this.pregnant_percent = parseFloat(this.parts/this.animals).toFixed(2);
            })
        })
    },

    dateFormatter(date, months){
        var month = date.getMonth();
        var year = date.getFullYear();
        var day = date.getDate();
        var lastDay = new Date(year, month, 0);
        if (month === 0) {
            month = 11;
            year = year - 1;
        } else {
            month = month - months;
        }
        if (day > lastDay.getDate()) {
            day = lastDay.getDate();
        }
        var newDate = new Date(year, month, 1);
        return newDate;
    },
    fillData(){
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchAnimals(config);
        this.fetchReproductive(config);
    },
  },
  watch:{
    'init_date': function(val){
        console.log(val);
        this.fillData();
    },
    'end_date': function(val){
        console.log(val);
        this.fillData();
    },
    
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    let now = new Date()
    let dateReg= new Date(now.getFullYear(), now.getMonth(), 1);
    this.fetchAnimals(config);
    //this.fetchAnimalsPregnant(config);
    this.fetchAnimalsDryed(config);
    this.fetchReproductive(config);
  },
}
</script>

<style>
.reportTitle {

    font-weight: 600;
    font-size: 24px;

}

.indicaterEco {
    font-weight: 500;
    font-size: 18px;
}
</style>